export default __webpack_public_path__ + "static/media/AmericanExpress.d972a8b2.svg";